import { useMemo } from 'react';

import { type CheckboxProps } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';
import { DeliveryType } from 'src/api/v2';

const useDeliveryTypeOptions = (selectedDeliveryTypes?: string[]) => {
  const { t } = useTranslation('oneWayIn');
  const deliveryTypeOptions: CheckboxProps[] = useMemo(
    () => [
      {
        label: t(`deliveryType.${DeliveryType.Lavrisikolaan}`),
        value: DeliveryType.Lavrisikolaan,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Lavrisikolaan) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Risikolaan}`),
        value: DeliveryType.Risikolaan,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Risikolaan) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Egenkapital}`),
        value: DeliveryType.Egenkapital,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Egenkapital) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Garantier}`),
        value: DeliveryType.Garantier,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Garantier) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Tilskudd}`),
        value: DeliveryType.Tilskudd,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Tilskudd) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Foredrag}`),
        value: DeliveryType.Foredrag,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Foredrag) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Kurs}`),
        value: DeliveryType.Kurs,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Kurs) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Raadgivning}`),
        value: DeliveryType.Raadgivning,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Raadgivning) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Connecting}`),
        value: DeliveryType.Connecting,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Connecting) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Fellesarrangementer}`),
        value: DeliveryType.Fellesarrangementer,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Fellesarrangementer) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Orientering}`),
        value: DeliveryType.Orientering,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Orientering) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Prosjektarbeid}`),
        value: DeliveryType.Prosjektarbeid,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Prosjektarbeid) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Publikasjon}`),
        value: DeliveryType.Publikasjon,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Publikasjon) ?? false,
      },
      {
        label: t(`deliveryType.${DeliveryType.Selvbetjening}`),
        value: DeliveryType.Selvbetjening,
        checked: selectedDeliveryTypes?.includes(DeliveryType.Selvbetjening) ?? false,
      },
    ],
    [selectedDeliveryTypes, t],
  );

  return { deliveryTypeOptions };
};

export default useDeliveryTypeOptions;
